// extracted by mini-css-extract-plugin
export default {"table":"TablaMateriasDetalle_table__NOanL","button":"TablaMateriasDetalle_button__Jav2J","buttonChanged":"TablaMateriasDetalle_buttonChanged__NhMzu"};